import { render, staticRenderFns } from "./gtr-file-upload.vue?vue&type=template&id=a3b1fbe6&scoped=true"
import script from "./gtr-file-upload.ts?vue&type=script&lang=ts&external"
export * from "./gtr-file-upload.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-file-upload.vue?vue&type=style&index=0&id=a3b1fbe6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b1fbe6",
  null
  
)

export default component.exports